/**
 * Copyright (c) 2019 7thCode. All Rights Reserved.
 * see license.txt
 */

import {Component, OnInit} from "@angular/core";
import {Overlay} from "@angular/cdk/overlay";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {BreakpointObserver} from "@angular/cdk/layout";

import {Callback, IErrorObject} from "../../../../types/platform/universe";
import {MessageDialogComponent} from "../base/components/message-dialog/message-dialog.component";

import {ResponsiveComponent} from "../../platform/base/components/responsive.component";
import {SessionService} from "../../platform/base/services/session.service";

import {InquiriesService} from "../inquiry/inquiries.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: "app-contact",
	templateUrl: "./contact.component.html",
	styleUrls: ["./contact.component.css"]
})
export class ContactComponent extends ResponsiveComponent implements OnInit {

	public params: any = {};
	public size: number = 5;
	public count: number = 0;
	public contacts: any[] = [];
	private query: object = {};
	private sort: object = {create: -1};
	private page: number = 0;

	constructor(
		protected session: SessionService,
		protected overlay: Overlay,
		protected inquiriesService: InquiriesService,
		protected breakpointObserver: BreakpointObserver,
		private matDialog: MatDialog,
		private router: Router,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session, breakpointObserver);
	}

	/**
	 * @returns none
	 */
	public onContact(event: any): void {
		this.draw((error, results) => {
			if (!error) {
				this.contacts = results;
			} else {
				this.errorDialog(error);
			}
		})
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		super.ngOnInit();
		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {
				this.route.queryParams.subscribe(params => {
					this.params = params;
					this.draw((error, results) => {
						if (!error) {
							this.contacts = results;
						} else {
							this.errorDialog(error);
						}
					})
				});
			}
		});
	}

	/**
	 * todo
	 */
	public toDate(date_string: string): Date {
		return new Date(date_string);
	}

	/**
	 * 再描画
	 * @param callback コールバック
	 */
	public draw(callback: Callback<object[]>): void {
		this.inquiriesService.count(this.query, (error: IErrorObject, result: any): void => {
			if (!error) {
				this.count = result.value;
				const option: any = {sort: this.sort, skip: this.size * this.page, limit: this.size};
				this.inquiriesService.query(this.query, option, (error: IErrorObject, results: any[]): void => {
					if (!error) {
						callback(null, results);
					} else {
						callback(error, null);
					}
				});
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	public Page(event: any): void {
		this.page = event.pageIndex;
		this.draw((error, results) => {
			if (!error) {
				this.contacts = results;
			} else {
				this.errorDialog(error);
			}
		})
	}

	/**
	 * メッセージダイアログ
	 *
	 * @returns none
	 */
	private messageDialog(message: string, callback: (result: any) => void = (result: any) => {}): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			data: {content: {title: "", message: message, tag: ""}},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: any): void => {
			callback(result);
		});
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}
}
